var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.rootTag, _vm._g(_vm._b({
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: _setup.computedRipple,
      expression: "computedRipple"
    }],
    tag: "component",
    class: _setup.classes,
    on: {
      "click": _setup.handleClick,
      "keydown": _setup.handleKeydown
    }
  }, 'component', _setup.boundAttrs, false), _setup.forwardedListeners), [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };